import { get, post } from '@elementary/common-ui/utils/http';
import {
  GenerateGPGKeyRequest,
  GPGKeyGenerationResponse,
  GPGKeyResponse,
} from '../types';

export const listGPGKeys = async (): Promise<GPGKeyResponse[]> => {
  const response = await get(
    `${import.meta.env.VITE_API_BASE_URL}/user/gpg-keys`,
  );
  return response;
};

export const generateGPGKey = async (
  request: GenerateGPGKeyRequest,
): Promise<GPGKeyGenerationResponse> => {
  const response = await post(
    `${import.meta.env.VITE_API_BASE_URL}/user/gpg-keys/generate`,
    {
      key_length: request.keyLength,
      expires_in_days:
        request.expiresInDays === -1 ? null : request.expiresInDays,
    },
  );

  return response;
};

export const revokeGPGKey = async (keyId: string): Promise<void> => {
  await post(
    `${import.meta.env.VITE_API_BASE_URL}/user/gpg-keys/${keyId}/revoke`,
  );
};
